<template>
  <div class="form-field form-autocomplete" :rel="name"
       v-bind:class="{'form-required': requiredForm, 'form-focus': focus, 'form-disabled':isDisabled}">
    <div class="form-label" v-show="label">{{ label }}</div>
    <div class="form-hint" v-show="hint">{{ hint }}</div>
    <div class="form-input" @click="handleManualClick">
      <div class="form-input-wrapper">

        <div>
          <div>

            <component-multiselect v-if="this.options"
                                   v-model="internalValue"
                                   :show-labels="false"
                                   :label="labelKey"
                                   track-by="id"
                                   value="String"
                                   :placeholder="labelPlaceholder"
                                   :options="options"
                                   :limit="100"
                                   :multiple="isMultiple"
                                   :internal-search="true"
                                   :clear-on-select="true"
                                   :show-no-results="true"
                                   :hide-selected="true"
                                   @close="focus = false"
                                   @open="focus = true"
                                   :disabled="isDisabled">
              <template slot="singleLabel" slot-scope="props">
                <div class="field-autocomplete-selectedline">
                  <div class="option__image" v-if="props.option.picture || props.option.icon || iconImage">
                    <img class="image" :src="props.option.picture" v-if="props.option.picture">
                    <span class="icon" v-bind:class="props.option.icon"
                          v-if="props.option.icon && !props.option.picture"></span>
                    <span class="icon" v-bind:class="iconImage" v-if="iconImage && !props.option.picture"></span>
                  </div>
                  <div class="option__desc">
                    <span class="option__title" v-if="props.option[labelKey]"
                          v-html="props.option[labelKey].escapeHTML() + '<i>'+props.option.id+'</i>'"></span>
                  </div>
                </div>
              </template>
              <template slot="option" slot-scope="props">
                <div class="field-autocomplete-line">
                  <div class="option__image" v-if="props.option.picture || props.option.icon || iconImage">
                    <img class="image" :src="props.option.picture" v-if="props.option.picture">
                    <span class="icon" v-bind:class="props.option.icon"
                          v-if="props.option.icon && !props.option.picture"></span>
                    <span class="icon" v-bind:class="iconImage" v-if="iconImage && !props.option.picture"></span>
                  </div>
                  <div class="option__desc">
                    <span class="option__title" v-if="props.option[labelKey]"
                          v-html="props.option[labelKey].escapeHTML() + '<i>'+props.option.id+'</i>'"></span>
                    <span class="option__description" v-if="props.option[labelDescription]"
                          v-html="props.option[labelDescription].escapeHTML()"></span>
                  </div>
                </div>
              </template>
              <template slot="tag" slot-scope="props">
                              <span class="multiselect__tag">
                                <span>{{ props.option[labelKey] }}</span>
                                <i aria-hidden="true" tabindex="1" @keydown.enter.prevent="props.remove(props.option)"
                                   @mousedown.prevent="props.remove(props.option)" class="multiselect__tag-icon"></i>
                              </span>
              </template>
            </component-multiselect>

          </div>
          <div class="bt-action" v-if="!isDisabled">
            <button class="bt-remove" @click="removeAll()"><i class="icon icon-icon_delete"></i></button>
          </div>
        </div>

        <!--
        <div v-for="item in debug" style="font-family: 'Courier New';font-size: 12px;">
          <strong>{{ item.label }}</strong>
          <pre>{{ item.data }}</pre>
        </div>
        -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormField',
  props: ['value', 'label', 'hint', 'name', 'description', 'placeholder', 'multiple', 'default', 'options', 'callback', 'required', 'icon', 'readonly', 'disabled'],
  data: function () {
    return {
      internalValue: null,
      labelField: null,
      focus: false,
      debug: [],
      isManuallyIntervened: null
    }
  },
  created: function () {
    //this.internalValue = this.value;
    this.isMultiple = this.multiple == 'true' ? true : false;
    this.onChange = this.callback ? true : false;
    this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
    this.iconImage = this.icon ? this.icon : null
    this.labelKey = this.name ? this.name : 'name'
    this.labelDescription = this.description ? this.description : 'description'
    this.labelField = this.label;
    this.labelPlaceholder = this.placeholder ? this.placeholder : "Rechercher..."
    this.readOnly = this.readonly && (this.readonly == 'true' || this.readonly == true) ? true : false
    this.setDisabled(this.disabled)

    this.debug.push({label:"Mount: ",data:this.value});

    this.setValue(this.value)
  },
  methods: {
    handleManualClick() {
      console.log('Manual intervention detected!');
      // Vous pouvez également mettre à jour une variable ici pour indiquer l'intervention
      this.isManuallyIntervened = true;
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },
    removeAll: function () {
      this.internalValue = [];
    },
    setValue: function (str) {

      let value = null;
      str = str ? str : this.default

      this.debug.push({label:"SetValue A : ", data:str});

      if (str == null || str === undefined) {
        this.debug.push({label:"SetValue B : ", data:null});
      }

      if (str && this.options) {

        let assigned = false

        for (let item of this.options) {
          if (item.id && item.id.toString().toLowerCase() == str.toString().toLowerCase()) {
            assigned = true
            value = item
            this.debug.push({label:"SetValue C : ", data:item});
          }
        }

        if (!assigned) {
          value = str;
          this.debug.push({label:"SetValue D : ", data:str});
        }
      }

      this.debug.push({label:"Emit: ",data:value});
      this.internalValue = value;
      this.$emit('input', value);
    },
    setDisabled: function (value) {
      this.isDisabled = value && (value == 'true' || value == true) ? true : false
      this.$forceUpdate();
    }
  },
  watch: {
    'disabled'(newVal, oldVal) {
      this.setDisabled(newVal)
    },
    'options'(newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        console.log("options:" + this.label, newVal, this.internalValue)
        this.options = newVal
        this.debug.push({label:"Watch 'options': ",data:newVal});
        this.setValue(this.internalValue)
        //this.setDefault(this.default);
      }
    },
    'default'(newVal, oldVal) {
      if( newVal != oldVal && newVal != this.internalValue )
      {
        this.debug.push({label:"Watch 'default' validated: ", data:[newVal, oldVal, this.internalValue]});
        this.setValue(newVal)
      }
    },
    'value'(newVal, oldVal) {
      if( newVal != oldVal && newVal != this.internalValue )
      {
        this.debug.push({label:"Watch 'value' validated: ", data:[newVal, oldVal, this.internalValue]});
        this.setValue(newVal)
      }
    },
    'internalValue': {
      handler: function (newVal, oldVal) {
        if (newVal != oldVal) {
          //this.debug.push({label:"Emit: ",data:newVal});
          this.$emit('input', newVal);
          if (this.internalValue && this.onChange) {
            let val = JSON.parse(JSON.stringify(this.internalValue))
            console.log('Item Selected: ' + this.label, val, this.default);
            this.debug.push({label:"Callback : ",data:val});
            this.callback(val, this.isManuallyIntervened)
          }
        }
      },
      deep: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/form/SelectNew.vue